// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2YYA4","imageUploader":"EGiftCard_imageUploader__3DqXB"};